interface aosDataset {
  aos: string,
  aosDuration?: string,
  easing?: string
}
interface aosTypes {
  selector: string,
  dataset: aosDataset
  wrapper?: string
}

const aosConfiguration: aosTypes[] = [
  {
    selector: ".sb-c-accordion__content",
    dataset: {
      aos: "fade-in",
      aosDuration: "1000",
    }
  },
  {
    selector: ".sb-c-text-block__content",
    dataset: {
      aos: "fade-right",
      aosDuration: "1000",
    }
  },
  {
    selector: ".sb-c-header__body",
    dataset: {
      aos: "fade-right",
      aosDuration: "1000",
    }
  },
  {
    selector: ".button-container",
    dataset: {
      aos: "fade-right",
      aosDuration: "700",
    }
  },
  {
    selector: ".sb-articles-container .button-container",
    dataset: {
      aos: "fade-up",
      aosDuration: "300",
    }
  },
  {
    selector: ".sb-articles",
    dataset: {
      aos: "fade-up",
      aosDuration: "1000",
    }
  },
  {
    selector: ".sb-c-slider__left",
    dataset: {
      aos: "fade-right",
      aosDuration: "1500",
    }
  },
  {
    selector: ".sb-c-slider__right",
    dataset: {
      aos: "fade-left",
      aosDuration: "1500",
    }
  },
  {
    selector: ".sb-c-slider__headline",
    dataset: {
      aos: "fade-left",
      aosDuration: "500",
    }
  },
  {
    selector: ".sb-c-slider__body",
    dataset: {
      aos: "fade-left",
      aosDuration: "500",
    }
  },
  {
    selector: ".sb-company-logo",
    dataset: {
      aos: "fade-up",
      easing: "easeOut"
    }
  },
  {
    selector: ".sb-c-content__headline",
    dataset: {
      aos: "fade-up",
    }
  },
]

export {
  aosConfiguration,
}
